import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const Counter = ({ start, end }) => {
  const { ref, inView } = useInView({ triggerOnce: false }); // Detect when in viewport
  const [count, setCount] = useState(start);

  useEffect(() => {
    if (inView) {
      let current = start;
      setCount(start); // Reset count when re-entering

      const increment = Math.ceil((end - start) / 50); // Adjust speed
      const interval = setInterval(() => {
        current += increment;
        if (current >= end) {
          setCount(end);
          clearInterval(interval);
        } else {
          setCount(current);
        }
      }, 50);

      return () => clearInterval(interval);
    }
  }, [inView, start, end]);

  return (
    <span ref={ref} className="md:text-5xl text-[20px] font-bold">
      {count}+
    </span>
  );
};

export default function Count() {
  return (
    <div className=" text-white  font-[Nunito] ml-[5%] mr-[5%]">
      <div className="container  flex justify-between text-center">
        {/* Projects */}
        <div className="mt-15">
          <Counter start={0} end={200} />
          <p className="md:text-lg " >Projects Complete</p>
        </div>

        {/* Happy Clients */}
        <div className="mt-15">
          <Counter start={0} end={100} />
          <p className="md:text-lg">Happy Clients</p>
        </div>

        {/* Years Experience */}
        <div className="mt-15">
          <Counter start={0} end={10} />
          <p className="md:text-lg">Years Experience</p>
        </div>

        {/* Awards Won */}
        <div className="mt-15">
          <Counter start={0} end={15} />
          <p className="md:text-lg">Awards Won</p>
        </div>
      </div><br /><br /><br />
    </div>
  );
}
